import styled from "@emotion/styled";
import { Button } from "@mui/material";
import ShoppingCartFilledIcon from "@mui/icons-material/ShoppingCart";
import StyleFilledIcon from "@mui/icons-material/Style";
import Snackbar from "@mui/material/Snackbar";
import Chip from "@mui/material/Chip";

export const PageHeaderContainer = styled.div<{ isSnackbarOpen: boolean }>(({ theme, isSnackbarOpen }) => ({
	display: "flex",
	justifyContent: "space-between",
	alignItems: "center",
	padding: "5px 32px",
	backgroundImage: "linear-gradient(to right, #006594, #ffffff)",
	h1: {
		...theme.project.typography.heading.h4,
		color: theme.project.colors.fontColors.label,
		fontWeight: 400,
		margin: 0,
		fontsize: "34px",
		cursor: "pointer",
		userSelect: "none",
		"&:hover": {
			textDecoration: "underline"
		},
		"&:focus-visible": {
			outline: `2px solid ${theme.project.colors.primaryColors.main}`,
			outlineOffset: "2px"
		}
	},
	[theme.breakpoints.down("sm")]: {
		marginBottom: isSnackbarOpen ? "80px" : "unset"
	}
}));

export const PageHeaderButtons = styled.div({
	display: "flex",
	maxWidth: "140px"
});

export const AddToCartSnackbar = styled(Snackbar)<{ isSales: boolean }>(({ theme, isSales }) => ({
	[theme.breakpoints.up("md")]: {
		right: isSales ? "180px" : "120px"
	},
	[theme.breakpoints.down("sm")]: {
		top: "160px"
	},
	div: {
		backgroundColor: theme.project.colors.semanticColors.success,
		color: theme.project.colors.secondaryColors.primary
	}
}));

export const CartButton = styled(Button)(({ theme }) => ({
	color: theme.project.colors.primaryColors.main,
	padding: "8px 24px",
	position: "relative",
	display: "flex",
	flexDirection: "column",
	".MuiChip-root": {
		maxWidth: "unset"
	}
}));

export const CartChip = styled(Chip)({
	backgroundColor: "var(--light-blue-500)",
	color: "#fff"
});

export const ShoppingCartButton = styled(ShoppingCartFilledIcon)({
	transform: "scaleX(-1)"
});

export const CampaignButton = styled(StyleFilledIcon)({
	transform: "scaleX(-1)"
});
